<template>
        
    <div class="row">
        <div class="col-12">
            <div class="d-flex flex-column mb-1">
                <small v-for="(att,index) in attachment" :key="index" class="mt-2 mr-3 d-flex align-items-center">
                    {{ att.name }}

                    <a href="#" class="text-danger ml-1" @click="removeAttachment(index)">
                        <fa :icon="['fal','times']" />
                    </a> 
                </small>
            </div>

            <button class="btn btn-primary btn-sm attach-btn" v-tooltip="$t('attach_files')" :disabled="loading">
                <label class="" title="Välj fil" for="customFile">
                    <fa :icon="['far','paperclip']" fixed-width /> Välj filer
                </label>
                <input type="file" class="d-none" id="customFile" multiple @change="setFile" ref="files">
            </button>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import autosize from 'autosize'
import Form from 'vform'

export default {
    name : 'Attachments',
    mounted(){
    },
    data(){
        return {
            loading: false,
            hasError: '',
            attachment : [],
            form : new Form({
                applies_to : "",
                comment : ''
            })
        }
    },
    methods : {
        setFile(ev){
            this.attachment = Array.from(ev.target.files);
            this.parseAttachments();
        },
        removeAttachment(index){
            this.attachment.splice(index,1);
        },
        parseAttachments(){            
            let formData = new FormData();

            if(this.attachment){
                for (var i = 0; i < this.attachment.length; i++) {
                    formData.append('attachment[' + i + ']', this.attachment[i]);
                }
            }

            this.$emit('attached',formData);
        },
    }
}
</script>

<style lang="scss" scoped>
    /*.attach-btn {
        background: transparent;
        border: none;
        z-index: 99;
        padding-right: .5rem;
        position: absolute;
        left: -2.5rem;
        top: .3rem;
        
        &:hover, &:hover svg, &:hover label {
            cursor: pointer;
        }
    }

    .comment-input {
        resize: none;
        overflow: hidden;
    }

    .custom-select {
        min-width: 150px;
    }*/
</style>




// WEBPACK FOOTER //
// resources/assets/js/components/Attachments.vue